export default "__VITE_ASSET__DA0B0z7H__"